import React, { useState, useEffect, useRef } from 'react';
import domainName from '../../domainName'
import { useSelector } from 'react-redux';

import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import { COLORS } from "../../colorTheme/colorTheme";
import AdvisorCard from '../../components/AdvisorCard';
import { useTranslation } from "react-i18next";


const Favourite = () => {

    const { token, UserData, UserId, latitude, longitude } = useSelector((state) => state.login);

    // set data from API
    const [favouriteListing, setFavouriteListing] = useState([])

    const [t] = useTranslation("global");

    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const sentinelRef = useRef(null);

    const fetchFavourites = async (page = 1) => {
        setIsLoading(true);
        try {
            const resRaw = await domainName.serverAPICall(
                domainName.debugAPI + "/service/exploreFavouriteSearviceListing",
                "POST",
                JSON.stringify({
                    "PageNum": page,
                    "ResultNum": 8,
                }),
                UserId,
                latitude,
                longitude
            );
            const response = await domainName.handleServerAPICallErrors(resRaw);
            const newData = response.Data || [];

            if (page === 1) {
                setFavouriteListing(newData);
            } else {
                setFavouriteListing(prev => [...prev, ...newData]);
            }

            if (newData.length < 8) {
                setHasMore(false);
            }
        } catch (err) {
            console.log("❌ Error in fetchFavourites", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (UserId) {
            setCurrentPage(1);
            setHasMore(true);
            fetchFavourites(1);
        }
    }, [UserId]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting && hasMore && !isLoading) {
                    setCurrentPage(prevPage => {
                        const nextPage = prevPage + 1;
                        fetchFavourites(nextPage);
                        return nextPage;
                    });
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            }
        );

        const timer = setTimeout(() => {
            if (sentinelRef.current) observer.observe(sentinelRef.current);
        }, 300);

        return () => {
            clearTimeout(timer);
            observer.disconnect();
        };
    }, [favouriteListing, hasMore, isLoading]);


    return (
        <Container className="width95" style={{ height: 'auto' }}>
            <Row>
                <Col>
                    <div className="w-100 mt-2 mb-1"><span style={{ fontWeight: 'bold', fontSize: 25 }}>{t('favourite.Favourite')}</span></div>
                    <br />
                </Col>
            </Row>

            <Row>

                {favouriteListing.map((item, index) => (
                    <AdvisorCard key={index} item={item} />
                ))}

            </Row>

            {/* Loading spinner or sentinel for infinite scroll */}
            <div ref={sentinelRef} style={{ height: '1px', marginTop: '60px' }}></div>

        </Container>
    )
}

export default Favourite

